(function () {
  var info = document.querySelector('product-info');
  if (!info) return;

  // Sticky add to cart bar (mobile). Mirrors the main buy button.
  var bar = document.querySelector('.hgSb');
  var buy = info.querySelector('.product-form__submit');
  if (bar && buy) {
    var price = bar.querySelector('b');
    var picks = bar.querySelector('span');
    var button = bar.querySelector('button');
    button.addEventListener('click', function () {
      buy.click();
    });
    var labelText = function (label) {
      var text = label.textContent;
      var hidden = label.querySelector('.visually-hidden');
      if (hidden) text = text.replace(hidden.textContent, '');
      return text.trim();
    };
    var sync = function () {
      var box = info.querySelector('.price');
      var item =
        box &&
        box.querySelector(box.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular');
      price.textContent = item ? item.textContent.trim().replace(' USD', '') : '';
      picks.textContent = Array.prototype.map
        .call(info.querySelectorAll('variant-radios input:checked + label'), labelText)
        .join(' / ');
      button.textContent = buy.textContent.trim();
      button.disabled = buy.disabled;
    };
    var toggle = function () {
      var on = buy.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('on', on);
      document.body.classList.toggle('hgSbOn', on);
    };
    sync();
    toggle();
    window.addEventListener('scroll', toggle, { passive: true });
    new MutationObserver(sync).observe(info, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled'],
    });
  }

  // Afterpay widget sometimes renders its logo as the text "undefined". Swap in the name.
  var fixAfterpay = function () {
    var host = document.querySelector('square-placement');
    var logo = host && host.shadowRoot && host.shadowRoot.querySelector('.afterpay-logo');
    if (logo && logo.textContent.trim() === 'undefined') {
      logo.textContent = 'Afterpay';
      logo.style.cssText =
        'color:#fff;font:inherit;font-weight:700;width:auto;height:auto;background:none;border:0;padding:0;cursor:pointer';
    }
  };
  var watchAfterpay = function () {
    var runs = 0;
    var timer = setInterval(function () {
      fixAfterpay();
      if (++runs > 20) clearInterval(timer);
    }, 500);
  };
  watchAfterpay();
  info.addEventListener('change', watchAfterpay);
})();
